module.exports = __webpack_public_path__ + "img/7775c3b888bec401c922129ff6e51e8.12e755e2.png";